
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/knowledge/category/[slug]",
      function () {
        return require("private-next-pages/knowledge/category/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/knowledge/category/[slug]"])
      });
    }
  